var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVPlusMarkBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 14.6957H30.7642V18H28.252V14.6957H25V12.2885H28.252V9H30.7642V12.2885H34V14.6957Z",
    fill: "#05CE88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42602 0H4.13867H0L8.90325 22H13.0419H17.3293L8.42602 0Z",
    fill: "#05CE88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7749 14.3011L15.0039 4.98316L23.6412 1.71289L18.7749 14.3011Z",
    fill: "#05CE88"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVPlusMarkBig);
export default __webpack_public_path__ + "static/media/v-plus-mark-big.55c446f5.svg";
export { ForwardRef as ReactComponent };